import { render } from '../../core/shell.js';
import { S, UI, save } from '../../core/store.js';
import { closeModal, openModal, toast } from '../../core/ui.js';
import { $, uid, val } from '../../core/util.js';

export const actions={
ch(el){UI.ch=el.dataset.id;delete S.unread[UI.ch];save();UI.nav=0;render()},
chnew(){openModal('New channel','<div class="field"><span>Channel name</span><input id="ch-name" placeholder="e.g. equipment"></div>','<button class="btn" data-act="mclose">Cancel</button><button class="btn pri" data-act="chcreate">Create channel</button>')},
chcreate(){const n=val('ch-name').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');if(!n){toast('Name the channel');return}const id='c-'+uid();S.channels.push({id,name:n,kind:'channel'});S.msgs[id]=[];UI.ch=id;save();closeModal();render()},
send(){const i=$('#msgin');const t=i&&i.value.trim();if(!t)return;(S.msgs[UI.ch]=S.msgs[UI.ch]||[]).push({id:uid(),u:S.me,t:Date.now(),text:t});save();UI._keep='#msgin';render()}
};
